<template>
  <div class="message-container d-flex justify-content-begin mb-2 inbound">
    <div class="message">
      <div class="header font-weight-bold">
        <span class="contact-filemaker-id" v-if="contactFilemakerId">{{ contactFilemakerId }}</span>
        <span class="contact-full-name">{{ contactFullName | uppercase }}</span>
      </div>
      <div class="content d-flex flex-column">
        <div class="content-body w-100 d-flex">
          <div class="message-content w-100">{{ content }}</div>
          <message-settings :settings="settings" :message="model"></message-settings>
        </div>
        <media-list :media="media" v-if="hasMedia"></media-list>
      </div>
      <div class="footer text-black-50">
        {{ statusString | uppercase }}
      </div>
    </div>
  </div>
</template>

<script>
import MediaList from "../media-list";
import MessageSettings from "../message-settings";

export default {
  props: {
    model: Object,
    settings: Array,
  },

  components: {
    MediaList,
    MessageSettings,
  },

  computed: {
    /**
     * @return {Object}
     */
    conversation() {
      return _.get(this.model, 'conversation');
    },

    /**
     * @return {Object}
     */
    contact() {
      return _.get(this.conversation, 'contact');
    },

    /**
     * @return {String}
     */
    contactFilemakerId() {
      return _.get(this.contact, 'filemaker_id');
    },

    /**
     * @return {boolean}
     */
    hasMedia() {
      return !_.isEmpty(_.get(this.model, 'media'));
    },

    /**
     * @return {Object}
     */
    media() {
      return _.get(this.model, 'media');
    },

    /**
     * @return {String}
     */
    content() {
      return String(_.get(this.model, 'content') || '').trim();
    },

    /**
     * @return {String}
     */
    statusString() {
      return 'SEND: ' + (this.formatTime(this.messageSendAt) || '');
    },

    /**
     * @return {Object|null}
     */
    messageSendAt() {
      return _.get(this.model, 'send_at');
    },

    /**
     * @return {String}
     */
    contactFullName() {
      return _.get(this.contact, 'full_name', null);
    },
  },

  methods: {
    /**
     * @param {Object|null} date
     * @return {String|null}
     */
    formatTime(date) {
      return date
          ? moment(date.iso).format('ddd, MMM D, YYYY ') + date.time
          : null;
    },
  },
}
</script>

<style scoped>

</style>
